import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { TriggerApiService } from 'src/api/trigger'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadEvents, loadEventsFailure, loadEventsSuccess } from './event.actions'

@Injectable()
export class EventEffects {
  private actions$ = inject(Actions)
  private triggerApi = inject(TriggerApiService)
  private toaster = inject(ToasterService)


  loadEvents$ = createEffect(() => this.actions$.pipe(
    ofType(loadEvents),
    switchMap(() =>
      from(this.loadAllEvents()).pipe(
        map(events => loadEventsSuccess({ events })),
        catchAndLog(this.toaster, 'Unable to fetch events', loadEventsFailure)))))

  private async loadAllEvents(): Promise<any[]> {
    try {
      const { data } = await this.triggerApi.getEventTypes()
      return data || []
    } catch (err) {
      console.error('Unable to load events', err)
      return []
    }
  }
}

